import React from 'react'
import { Instance } from 'mobx-state-tree'
import { Platform, TextStyle, View, ViewStyle } from 'react-native'
import { SvgXml } from 'react-native-svg'

import { Branding } from '@trivie/core/src/models/Branding'

import { Text } from '../text'

interface ResultChoiceProps {
  branding?: Instance<typeof Branding>
  selected: boolean
  choice: any
  style?: ViewStyle
  multi?: boolean
}

export const ReviewMultipleChoice = (props: ResultChoiceProps) => {
  const { style, multi, selected, branding, choice } = props

  const renderChoiceText = () => {
    let textColor = `${branding!.review_background_text}50`
    if (choice.correct) {
      textColor = branding!.correct_answer
    } else if (selected && !choice.correct) {
      textColor = branding!.incorrect_answer
    }

    return (
      <Text disableLink style={{ ...CHOICE_TEXT, color: textColor }} text={choice.choice_text} />
    )
  }

  return (
    <View style={{ ...CHOICE_CONTAINER, ...style }}>
      <ChoiceIndicator
        multi={multi}
        branding={branding}
        selected={selected}
        correct={choice.correct}
      />
      {renderChoiceText()}
    </View>
  )
}

const ChoiceIndicator = (props: any) => {
  const { selected, correct, branding, multi } = props
  return (
    <>
      <View
        style={{
          ...OUTER_CIRCLE,
          borderRadius: multi ? 2 : 100,
          opacity: selected && !multi ? 0.5 : 1.0,
          backgroundColor:
            !selected && correct
              ? branding.correct_answer
              : !selected && !correct
                ? `${branding!.review_background_text}20`
                : correct
                  ? branding.correct_answer
                  : branding.incorrect_answer,
        }}
      />
      {multi && selected ? (
        <View style={{ ...MULTI, backgroundColor: branding.review_background }}>
          {Platform.OS === 'web' ? (
            <svg
              width="10"
              height="9"
              viewBox="0 0 10 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.46971 6.65706L1.81289 4.72544C1.72369 4.62121 1.60257 4.56263 1.47628 4.56263C1.34998 4.56263 1.22887 4.62121 1.13966 4.72544C0.953447 4.94254 0.953447 5.29324 1.13966 5.51033L3.13548 7.83718C3.3217 8.05427 3.6225 8.05427 3.80871 7.83718L8.86034 1.94771C9.04655 1.73061 9.04655 1.37991 8.86034 1.16282C8.77113 1.05858 8.65002 1 8.52372 1C8.39743 1 8.27631 1.05858 8.18711 1.16282L3.46971 6.65706Z"
                fill={correct ? branding.correct_answer : branding.incorrect_answer}
                stroke={correct ? branding.correct_answer : branding.incorrect_answer}
              />
            </svg>
          ) : (
            <SvgXml
              xml={`<svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.46971 6.65706L1.81289 4.72544C1.72369 4.62121 1.60257 4.56263 1.47628 4.56263C1.34998 4.56263 1.22887 4.62121 1.13966 4.72544C0.953447 4.94254 0.953447 5.29324 1.13966 5.51033L3.13548 7.83718C3.3217 8.05427 3.6225 8.05427 3.80871 7.83718L8.86034 1.94771C9.04655 1.73061 9.04655 1.37991 8.86034 1.16282C8.77113 1.05858 8.65002 1 8.52372 1C8.39743 1 8.27631 1.05858 8.18711 1.16282L3.46971 6.65706Z" fill="${
              correct ? branding.correct_answer : branding.incorrect_answer
            }" stroke="${correct ? branding.correct_answer : branding.incorrect_answer}"/>
             </svg>
          `}
            />
          )}
        </View>
      ) : (
        <View
          style={{
            ...INNER_CIRCLE,
            borderColor: branding.review_background,
            backgroundColor: !selected
              ? branding.review_background
              : selected && correct
                ? branding.correct_answer
                : branding.incorrect_answer,
            borderRadius: multi ? 0 : 100,
          }}
        />
      )}
    </>
  )
}

const CHOICE_CONTAINER: ViewStyle = { alignItems: 'center', flexDirection: 'row', paddingRight: 20 }
const CHOICE_TEXT: TextStyle = {
  paddingLeft: 18,
  fontSize: 14,
  alignSelf: 'center',
}
const MULTI: ViewStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'absolute',
  height: 15,
  width: 15,
  borderRadius: 2,
  left: 2.5,
}
const INNER_CIRCLE: ViewStyle = {
  position: 'absolute',
  height: 15,
  width: 15,
  left: 2.5,
  borderWidth: 3,
  alignSelf: 'center',
}
const OUTER_CIRCLE: ViewStyle = { height: 20, width: 20 }
